import BaseRoute from 'seshy/routes/base';
import { service } from '@ember/service';
import { pushPayload } from 'seshy/utils/push-payload';
import { action } from '@ember/object';
import { hash } from 'rsvp';

export default class AuthenticatedPlaylistsIndexRoute extends BaseRoute {
  @service store;
  @service currentUser;

  async model(params) {
    let playlists = this.store.findAll('playlist', {
      include:
        'owning-team,playlist-entries,playlist-entries.project,playlist-entries.project.current-bounce',
      // TODO: Figure out how to get rid of this. Without it we only get a partial list if you start
      // on the dashboard and then navigate to the playlists page.
      reload: true,
    });
    return hash({ playlists });
  }
}
